import { render, staticRenderFns } from "./NewsMain.vue?vue&type=template&id=07e3fdbe"
import script from "./NewsMain.vue?vue&type=script&lang=js"
export * from "./NewsMain.vue?vue&type=script&lang=js"
import style0 from "./NewsMain.vue?vue&type=style&index=0&id=07e3fdbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports